import Teacher from 'entities/Teacher';
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';

import { Backbone$Id } from 'types/typescript/Backbone';

class Teachers extends Collection<Teacher> {
  initialize() {
    // @ts-ignore tsc hates this way of initializing the model
    this.model = Teacher;
  }

  static getTeachersForOrganizationId(organizationId: Backbone$Id, query: string = '') {
    return apiRequest(`/organizations/${organizationId}/teachers`, 'GET', {
      query,
    }).then(response => Teachers.fromJSON(response) as Teachers);
  }
}

export default Teachers;
